export default "__VITE_ASSET__DGCvCbAD__"